export default __webpack_public_path__ + "static/media/slide1.454924ec.jpg";